import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import SectionTitleS2 from '../SectionTitleS2';
import sImg1 from '../../images/event-shape-1.png';
import sImg2 from '../../images/event-shape-2.png';

const hotels = {
    hu: [
        {
            name: 'Mini Hotel',
            website: 'https://minihotelpapa.hu/',
            location: 'Pápa (Sárzó Parktól 22,7 km, kocsival 24 perc)',
            availableRooms: '12 db 2 ágyas szoba, 1 db 4 ágyas szoba',
            rooms: [
                { type: '2 fős szoba', guests: '2 fő', price: '42 500 Ft / éj', note: '21 250 Ft/fő – idegenforgalmi adó benne' },
                { type: '4 fős apartman', guests: '4 fő', price: '57 000 Ft / éj', note: '14 250 Ft/fő – idegenforgalmi adó benne' },
            ],
            extras: [
                { label: 'Reggeli', value: 'Foglaláskor szükséges jelezni. Díja: 3 000 Ft/fő. Félpanzió esetén: 9 000 Ft/fő.' },
                { label: 'Bejelentkezés', value: '12:00-tól.' },
            ],
        },
        {
            name: 'Villa Classica Hotel',
            website: 'https://classicahotel.hu/hu/',
            location: 'Pápa (Sárzó Parktól 23,9 km, kocsival 25 perc)',
            availableRooms: '15 szoba (3 Standard franciaágyas, 6 Standard különágyas, 3 Superior, 3 Erkélyes Superior)',
            rooms: [
                { type: 'Standard franciaágyas szoba', guests: '1 fő', price: '38 250 Ft / éj', note: 'nem pótágyazható' },
                { type: 'Standard franciaágyas szoba', guests: '2 fő', price: '42 500 Ft / éj', note: 'nem pótágyazható' },
                { type: 'Standard különágyas szoba', guests: '1 fő', price: '38 250 Ft / éj', note: 'nem pótágyazható' },
                { type: 'Standard különágyas szoba', guests: '2 fő', price: '42 500 Ft / éj', note: 'nem pótágyazható' },
                { type: 'Superior szoba', guests: '1 fő', price: '41 650 Ft / éj', note: '2 fő részére pótágyazható' },
                { type: 'Superior szoba', guests: '2 fő', price: '45 900 Ft / éj', note: '' },
                { type: 'Superior szoba', guests: '2 fő + 1 gyermek (4–13 év)', price: '52 700 Ft / éj', note: '' },
                { type: 'Superior szoba', guests: '2 fő + 2 gyermek (4–13 év)', price: '59 500 Ft / éj', note: '' },
                { type: 'Superior szoba', guests: '3 fő', price: '54 400 Ft / éj', note: '' },
                { type: 'Superior szoba', guests: '3 fő + 1 gyermek (4–13 év)', price: '61 200 Ft / éj', note: '' },
                { type: 'Superior szoba', guests: '4 fő', price: '62 900 Ft / éj', note: '' },
                { type: 'Erkélyes Superior szoba', guests: '1 fő', price: '41 650 Ft / éj', note: '1 fő részére pótágyazható' },
                { type: 'Erkélyes Superior szoba', guests: '2 fő', price: '45 900 Ft / éj', note: '' },
                { type: 'Erkélyes Superior szoba', guests: '2 fő + 1 gyermek (4–13 év)', price: '52 700 Ft / éj', note: '' },
                { type: 'Erkélyes Superior szoba', guests: '3 fő', price: '54 400 Ft / éj', note: '' },
            ],
            includes: [
                'Szállás a választott szobatípusban',
                'Bőséges büféreggeli',
                'Feltöltődés az orientális wellness részlegében: finn és infraszauna, pihenőszoba',
                'Fürdőköntös és szaunatörölköző',
                'Kikapcsolódás a Safari klubban: biliárd, csocsó',
                'Kávé és tea bekészítés',
                'Információs térkép Pápa és a környék látnivalóiról',
                'Wi-Fi',
            ],
            extras: [
                { label: 'Idegenforgalmi adó', value: '750 Ft/felnőtt/éj (külön fizetendő)' },
                { label: '4 év alatti gyermek', value: 'ingyenes a szülők szobájában baba- vagy pótágyon' },
                { label: 'Bejelentkezés', value: '12:00-tól.' },
                { label: 'Kijelentkezés', value: '06:00–11:00' },
                { label: 'Korai be- / késői kijelentkezés', value: '2 500 Ft/szoba/óra, foglaltságtól függően' },
                { label: 'Parkolás – szállodai parkoló', value: 'ingyenes' },
                { label: 'Parkolás – teremgarázs', value: '2 500 Ft/autó/éj' },
                { label: 'Elektromos töltő (csak teremgarázzsal együtt)', value: '+5 000 Ft/autó/alkalom' },
            ],
        },
        {
            name: 'Ditlin Hotel',
            website: 'https://www.ditlin.hu/',
            location: 'Pápa (Sárzó Parktól 21,8 km, kocsival 22 perc)',
            availableRooms: '8 szoba, 2 apartman',
            rooms: [
                { type: 'Deluxe szoba', guests: '1 fő', price: '40 320 Ft / éj', note: 'reggeli benne, parkoló, WiFi benne' },
                { type: 'Deluxe szoba', guests: '2 fő', price: '44 350 Ft / éj', note: 'reggeli benne, parkoló, WiFi benne' },
                { type: 'Superior szoba', guests: '1 fő', price: '35 805 Ft / éj', note: 'reggeli benne, parkoló, WiFi benne' },
                { type: 'Superior szoba', guests: '2 fő', price: '39 305 Ft / éj', note: 'reggeli benne, parkoló, WiFi benne' },
                { type: 'Kristály apartman', guests: '4 fő', price: '46 200 Ft / éj', note: 'ellátás nélkül, 12 férőhely összesen' },
            ],
            extras: [
                { label: 'Az árak tartalmazzák', value: 'ÁFA, parkoló, WiFi' },
                { label: 'Idegenforgalmi adó', value: '750 Ft/fő/éjszaka (18 éves kortól, külön fizetendő)' },
                { label: 'Gyermek kedvezmény', value: '3 évnél fiatalabb gyermekek ingyenesen tartózkodhatnak a szülők szobájában kiságyban/pótágyon (foglaltságtól függően)' },
                { label: 'Reggeli', value: 'Szobák árába beleértve. Apartman esetén: 3 500 Ft/fő/alkalom (külön fizetendő)' },
                { label: 'Bejelentkezés', value: '12:00–22:00.' },
                { label: 'Kijelentkezés', value: '10:00–13:00' },
                { label: 'Korai be- / késői kijelentkezés', value: '2 500 Ft/szoba/óra, foglaltságtól függően' },
                { label: 'Parkolás – szoba', value: 'kamerázott parkoló, ingyenes' },
                { label: 'Parkolás – apartman', value: 'zárt parkoló (korlátozott számban), ingyenes' },
            ],
        },
    ],
    en: [
        {
            name: 'Mini Hotel',
            website: 'https://minihotelpapa.hu/',
            location: 'Pápa (22.7 km from Sárzó Park, ~24 min by car)',
            availableRooms: '12 double rooms, 1 quad room',
            rooms: [
                { type: 'Double room', guests: '2 guests', price: '42,500 HUF / night', note: '21,250 HUF/person – tourist tax included' },
                { type: 'Quad apartment', guests: '4 guests', price: '57,000 HUF / night', note: '14,250 HUF/person – tourist tax included' },
            ],
            extras: [
                { label: 'Breakfast', value: 'Must be requested at booking. 3,000 HUF/person. Half-board: 9,000 HUF/person.' },
                { label: 'Check-in', value: 'From 12:00.' },
            ],
        },
        {
            name: 'Villa Classica Hotel',
            website: 'https://classicahotel.hu/hu/',
            location: 'Pápa (23.9 km from Sárzó Park, ~25 min by car)',
            availableRooms: '15 rooms (3 Standard double, 6 Standard twin, 3 Superior, 3 Superior with balcony)',
            rooms: [
                { type: 'Standard double bed room', guests: '1 guest', price: '38,250 HUF / night', note: 'no extra bed' },
                { type: 'Standard double bed room', guests: '2 guests', price: '42,500 HUF / night', note: 'no extra bed' },
                { type: 'Standard twin room', guests: '1 guest', price: '38,250 HUF / night', note: 'no extra bed' },
                { type: 'Standard twin room', guests: '2 guests', price: '42,500 HUF / night', note: 'no extra bed' },
                { type: 'Superior room', guests: '1 guest', price: '41,650 HUF / night', note: 'extra bed for 2 guests possible' },
                { type: 'Superior room', guests: '2 guests', price: '45,900 HUF / night', note: '' },
                { type: 'Superior room', guests: '2 guests + 1 child (4–13 yrs)', price: '52,700 HUF / night', note: '' },
                { type: 'Superior room', guests: '2 guests + 2 children (4–13 yrs)', price: '59,500 HUF / night', note: '' },
                { type: 'Superior room', guests: '3 guests', price: '54,400 HUF / night', note: '' },
                { type: 'Superior room', guests: '3 guests + 1 child (4–13 yrs)', price: '61,200 HUF / night', note: '' },
                { type: 'Superior room', guests: '4 guests', price: '62,900 HUF / night', note: '' },
                { type: 'Superior room with balcony', guests: '1 guest', price: '41,650 HUF / night', note: 'extra bed for 1 guest possible' },
                { type: 'Superior room with balcony', guests: '2 guests', price: '45,900 HUF / night', note: '' },
                { type: 'Superior room with balcony', guests: '2 guests + 1 child (4–13 yrs)', price: '52,700 HUF / night', note: '' },
                { type: 'Superior room with balcony', guests: '3 guests', price: '54,400 HUF / night', note: '' },
            ],
            includes: [
                'Accommodation in the selected room type',
                'Generous buffet breakfast',
                'Oriental wellness: Finnish & infrared sauna, relaxation room',
                'Bathrobe and sauna towel',
                'Safari Club: billiards, foosball',
                'Coffee and tea',
                'Information map of Pápa and surroundings',
                'Wi-Fi',
            ],
            extras: [
                { label: 'Tourist tax', value: '750 HUF/adult/night (charged separately)' },
                { label: 'Children under 4', value: "free in parents' room in a cot or extra bed" },
                { label: 'Check-in', value: 'From 12:00.' },
                { label: 'Check-out', value: '06:00–11:00' },
                { label: 'Early check-in / late check-out', value: '2,500 HUF/room/hour, subject to availability' },
                { label: 'Parking – hotel lot', value: 'free' },
                { label: 'Parking – indoor garage', value: '2,500 HUF/car/night' },
                { label: 'EV charging (with garage only)', value: '+5,000 HUF/car/use' },
            ],
        },
        {
            name: 'Ditlin Hotel',
            website: 'https://www.ditlin.hu/',
            location: 'Pápa (21.8 km from Sárzó Park, ~22 min by car)',
            availableRooms: '8 rooms, 2 apartments',
            rooms: [
                { type: 'Deluxe room', guests: '1 guest', price: '40,320 HUF / night', note: 'breakfast, parking & WiFi included' },
                { type: 'Deluxe room', guests: '2 guests', price: '44,350 HUF / night', note: 'breakfast, parking & WiFi included' },
                { type: 'Superior room', guests: '1 guest', price: '35,805 HUF / night', note: 'breakfast, parking & WiFi included' },
                { type: 'Superior room', guests: '2 guests', price: '39,305 HUF / night', note: 'breakfast, parking & WiFi included' },
                { type: 'Kristály apartment', guests: '4 guests', price: '46,200 HUF / night', note: 'room only (no meals), 12 total beds' },
            ],
            extras: [
                { label: 'Prices include', value: 'VAT, parking, WiFi' },
                { label: 'Tourist tax', value: '750 HUF/person/night (from age 18, charged separately)' },
                { label: 'Children discount', value: 'Children under 3 stay free in parents\' room in a cot or extra bed (subject to availability)' },
                { label: 'Breakfast', value: 'Included in room prices. Apartment: 3,500 HUF/person/use (charged separately)' },
                { label: 'Check-in', value: '12:00–22:00.' },
                { label: 'Check-out', value: '10:00–13:00' },
                { label: 'Early check-in / late check-out', value: '2,500 HUF/room/hour, subject to availability' },
                { label: 'Parking – rooms', value: 'monitored parking lot, free' },
                { label: 'Parking – apartment', value: 'enclosed parking (limited spaces), free' },
            ],
        },
    ],
};

const SzallasokSection = () => {
    const { language } = useLanguage();
    const hotelList = hotels[language] || hotels.hu;

    const labels = {
        hu: {
            intro1: 'A szállásoktól az ajánlatot 2026. július 18–19. éjszakára kaptuk.',
            intro2: 'A foglaláskor jelezzétek, hogy Röhberg-Mihály Zsófia és Röhberg Péter esküvője kapcsán foglaltok szállást (2026. július 18.), így jár a kedvezményes ár.',
            intro3: 'A kedvezményes ár 2026. április 10-ig érvényes. Ezt követően a szálláshelyek magasabb árat számolhatnak.',
            location: 'Elhelyezkedés',
            available: 'Elérhető szobák',
            roomType: 'Szobatípus',
            guests: 'Vendégek',
            price: 'Ár/éj',
            includes: 'Az ár tartalmazza',
            details: 'Részletek',
            website: 'Szálláshely Weboldala',
        },
        en: {
            intro1: 'We received quotes from the accommodations for the night of July 18–19, 2026.',
            intro2: "When booking, please mention that you are reserving in connection with Röhberg-Mihály Zsófia & Röhberg Péter's wedding on July 18, 2026 — this is required to get the discounted rate.",
            intro3: 'The discounted rate is valid for bookings made by April 10, 2026. After this date, higher rates may apply.',
            location: 'Location',
            available: 'Available rooms',
            roomType: 'Room type',
            guests: 'Guests',
            price: 'Price/night',
            includes: 'Price includes',
            details: 'Details',
            website: 'Accommodation Website',
        },
    };

    const lbl = labels[language] || labels.hu;

    return (
        <section className="wpo-event-section section-padding" id="szallasok">
            <div className="container">
                <SectionTitleS2 MainTitle={language === 'hu' ? 'Szálláshelyek' : 'Accommodations'} />

                {/* Intro info card */}
                <div className="row justify-content-center" style={{ marginBottom: '40px' }}>
                    <div className="col col-lg-8 col-12">
                        <div className="wpo-event-item">
                            <div className="wpo-event-text" style={{ textAlign: 'center' }}>
                                <p>{lbl.intro1}</p>
                                <p>{lbl.intro2}</p>
                                <p>{lbl.intro3}</p>
                            </div>
                            <div className="event-shape-1"><img src={sImg1} alt="" /></div>
                            <div className="event-shape-2"><img src={sImg2} alt="" /></div>
                        </div>
                    </div>
                </div>

                {/* Hotel cards */}
                <div className="row">
                    {hotelList.map((hotel, idx) => (
                        <div className="col col-lg-4 col-md-6 col-12" key={idx}>
                            <div className="wpo-event-item">
                                <div className="wpo-event-text" style={{ textAlign: 'left', paddingBottom: '25px' }}>
                                    <h2 style={{ fontSize: '22px', textAlign: 'center' }}>{hotel.name}</h2>

                                    <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                                        <a href={hotel.website} target="_blank" rel="noopener noreferrer"
                                            style={{ color: '#8facc2' }}>
                                            {lbl.website}
                                        </a>
                                    </p>

                                    <p><strong>{lbl.location}:</strong><br />{hotel.location}</p>
                                    <p><strong>{lbl.available}:</strong><br />{hotel.availableRooms}</p>

                                    {/* Room pricing table */}
                                    <p style={{ marginTop: '16px', marginBottom: '6px' }}><strong>{lbl.roomType}</strong></p>
                                    <div style={{ overflowX: 'auto', marginBottom: '16px' }}>
                                        <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ borderBottom: '1px solid #c4d8e4' }}>
                                                    <th style={{ textAlign: 'left', padding: '4px 6px' }}>{lbl.roomType}</th>
                                                    <th style={{ textAlign: 'left', padding: '4px 6px' }}>{lbl.guests}</th>
                                                    <th style={{ textAlign: 'right', padding: '4px 6px' }}>{lbl.price}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {hotel.rooms.map((room, ridx) => (
                                                    <tr key={ridx} style={{ borderBottom: '1px solid #eaf1f5' }}>
                                                        <td style={{ padding: '5px 6px', verticalAlign: 'top' }}>
                                                            {room.type}
                                                            {room.note ? <span style={{ display: 'block', color: '#888', fontSize: '11px' }}>{room.note}</span> : null}
                                                        </td>
                                                        <td style={{ padding: '5px 6px', verticalAlign: 'top', whiteSpace: 'nowrap' }}>{room.guests}</td>
                                                        <td style={{ padding: '5px 6px', verticalAlign: 'top', textAlign: 'right', whiteSpace: 'nowrap', fontWeight: '600' }}>{room.price}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Includes list */}
                                    {hotel.includes && (
                                        <div style={{ marginBottom: '16px' }}>
                                            <p style={{ marginBottom: '6px' }}><strong>{lbl.includes}:</strong></p>
                                            <ul style={{ paddingLeft: '18px', fontSize: '13px', margin: 0 }}>
                                                {hotel.includes.map((item, iidx) => (
                                                    <li key={iidx} style={{ marginBottom: '3px' }}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {/* Extras */}
                                    <p style={{ marginTop: '16px', marginBottom: '8px' }}><strong>{lbl.details}:</strong></p>
                                    {hotel.extras.map((extra, eidx) => (
                                        <p key={eidx} style={{ fontSize: '13px', marginBottom: '4px' }}>
                                            <strong>{extra.label}:</strong> {extra.value}
                                        </p>
                                    ))}
                                </div>
                                <div className="event-shape-1"><img src={sImg1} alt="" /></div>
                                <div className="event-shape-2"><img src={sImg2} alt="" /></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SzallasokSection;
